var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"logo","src":require("../assets/logo.png")}}),_c('RecordForm',{attrs:{"taxRegimes":this.taxRegimes,"billerTypes":this.billerTypes,"company":this.company,"recordProp":this.record}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }